export default "__VITE_ASSET__ByGYbFX9__"